<template>
  <div>
    <div class="top-background">
    	<div class="home" @click="goindex">
  		  <!--<img src="@/assets/images/home.png"></img>-->
  		  <a-icon type="home" theme="filled" />
  		  <span>首页</span>
  	  </div>
      <div class="main-title">数字化转型赋能职业教育高质量发展</div>
      <div class="main-headline">
        <img src="@/assets/images/new/title-text.png" alt="" />
      </div>
    </div>
    <div class="content">
      <router-view></router-view>
    </div>
    <div class="footer">
      建议电脑显示分辨率为1024*768 浏览器版本为IE8以上或者其他浏览器进行浏览
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {
  	goindex(){
  		this.$router.push({path:'/home/index1'});
  	},
  },
};
</script>

<style lang="scss" scoped>
.top-background {
  width: 100%;
  height: 322px;
  background: url(~@/assets/images/new/top-background.png) no-repeat;
  background-size: 100% 100%;
  padding-top: 110px;
  margin-bottom: 26px;
  box-sizing: border-box;
  .main-title {
    background: url("~@/assets/images/new/title-img.png") no-repeat center
      center;
    background-size: auto auto;
    text-align: center;
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
  }
  .main-headline {
    text-align: center;
    margin-top: 26px;
  }
}
.content{
    min-height: calc(100vh - 378px);
}
.footer {
  width: 100%;
  height: 56px;
  line-height: 56px;
  text-align: center;
  background: #4765eb;
  margin-top: 20px;
}
.home{
  	width: 86px;
		height: 30px;
		background: rgba(255,255,255,0.2);
		border: 1px solid #1B42CB;
		border-radius: 4px;
		position: absolute;
		top:20px;
		right:100px;
		display: flex;
		padding:0px 10px;
		box-sizing: border-box;
		justify-content: space-around;
		cursor:pointer;
		align-items: center;
		img{
			width:13px;
			height:13px;
		}
}
</style>